<template>
  <section class="flex column">
    <div class="box w100">
      <div class="box-title">
        <b>Perfil do Lead</b>
      </div>
      <div v-if="!loading" class="box-content">
        <div class="flex column">
          <div>
            Email: {{ detail.lead && detail.lead.email | protect  }}
          </div>
          <div v-if="detail.lead.phone" class="margin-top-s">
            Telefone: {{ detail.lead.phone | protect  }}
          </div>
          <div v-else  class="margin-top-s"> Telefone: - </div>
          <div class="margin-top-s">
            Lead é Comprador? <span v-if="detail.sales && detail.sales.length > 0"> Sim</span> <span else> Não</span>
          </div>
        </div>
      </div>
      <div v-else>
        <content-loading>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
        </content-loading>
      </div>
    </div>

    <div class="box w100 margin-top-s">
      <div class="box-title">
        <b>Inscrições</b>
      </div>
      <div v-if="!loading" class="box-content">
        <div class="flex column">
          <div class="flex w100">
            <div class="flex-1">
              <b>Id</b>
            </div>
            <div class="flex-2">
              <b>Email</b>
            </div>
            <div class="flex-1">
              <b>Data</b>
            </div>
          </div>
          <div v-for="(s, key) in detail.subscriptions" :key="key" class="flex w100 margin-top-s">
            <div class="flex-1">
              {{ s.id | number }}
            </div>
            <div class="flex-2">
              {{ s.email | protect  }}
            </div>
            <div class="flex-1">
              {{ s.created_at | date }}
            </div>
          </div>
        </div>
      </div>
      <div v-else class="box-content">
        <content-loading>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
        </content-loading>
      </div>
    </div>

    <div class="box w100 margin-top-s">
      <div class="box-title">
        <b>Compras</b>
      </div>
      <div v-if="!loading" class="box-content">
        <div v-if="detail.sales && detail.sales.length > 0" class="flex column">
          <div class="flex w100">
            <div class="flex-2">
              <b>Id</b>
            </div>
            <div class="flex-1">
              <b>Plataforma</b>
            </div>
            <div class="flex-1">
              <b>Status</b>
            </div>
            <div class="flex-1">
              <b>Data</b>
            </div>
          </div>
          <div v-for="(s, key) in detail.sales" :key="key" class="flex w100 margin-top-s">
            <div class="flex-2">
              {{ s.order_id | protect  }}
            </div>
            <div class="flex-1">
              {{ s.platform }}
            </div>
            <div class="flex-1">
              {{ s.status }}
            </div>
            <div class="flex-1">
              {{ s.created_at | date }}
            </div>
          </div>
        </div>
        <div v-else> Não encontramos compras...</div>
      </div>
      <div v-else class="box-content">
        <content-loading>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
        </content-loading>
      </div>
    </div>

    <div class="box w100 margin-top-s">
      <div class="box-title">
        <b>Produtos</b>
      </div>
      <div v-if="!loading" class="box-content">
        <div v-if="detail.products && detail.products.length > 0" class="flex column">
          <div class="flex w100">
            <div class="flex-2">
              <b>Nome</b>
            </div>
          </div>
          <div v-for="(p, key) in detail.products" :key="key" class="flex w100 margin-top-s">
            <div class="flex-2">
              {{ p | protect  }}
            </div>
          </div>
        </div>
        <div v-else> Não encontramos produtos...</div>
      </div>
      <div v-else class="box-content">
        <content-loading>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
        </content-loading>
      </div>
    </div>

    <div class="box w100 margin-top-s">
      <div class="box-title">
        <b>Páginas Visitadas</b>
      </div>
      <div v-if="!loading" class="box-content">
        <div class="flex column">
          <div class="flex w100">
            <div class="flex-1">
              <b>Id</b>
            </div>
            <div class="flex-1">
              <b>Data</b>
            </div>
            <div class="flex-1">
              <b>Tipo de Visita</b>
            </div>
            <div class="flex-2">
              <b>Url</b>
            </div>
          </div>
          <div v-for="(s, key) in detail.trackers" :key="key" class="flex w100 column jorney-style">
            <div class="flex w100 margin-top-s middle">
              <div class="flex-1">
                {{ s.id | number  }}
              </div>
              <div class="flex-1">
                {{ s.created_at | date }}
              </div>
              <div v-if="s.track_type" class="flex-1">
                <b>{{ decodePv(s.track_type) }}</b>
              </div>
              <div v-if="!s.url.includes('no-page-tracker')" class="flex-2">
                <b>{{ s.url | protect  }}</b>
              </div>
              <div v-else class="flex-2"> - </div>
              
            </div>
            <div class="flex w100 margin-top-s column">
              <div class="flex-1 flex column">
                <span class="tag" v-if="checkParam(s.utm_campaign)">utm_campaign: {{ s.utm_campaign | protect  }}</span>
                <span class="tag" v-if="checkParam(s.utm_medium)">utm_medium: {{ s.utm_medium | protect  }}</span>
                <span class="tag" v-if="checkParam(s.utm_source)">utm_source: {{ s.utm_source | protect  }}</span>
                <span class="tag" v-if="checkParam(s.utm_content)">utm_content: {{ s.utm_content | protect  }}</span>
                <span class="tag" v-if="checkParam(s.utm_term)">utm_term: {{ s.utm_term | protect  }}</span>
                <span class="tag" v-if="checkParam(s.src)">src: {{ s.src | protect  }}</span>
                <span class="tag" v-if="checkParam(s.sck)">sck: {{ s.sck | protect  }}</span>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div v-else class="box-content">
        <content-loading>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
        </content-loading>
      </div>
    </div>
  </section>
</template>

<script>

import { 
  getLead
} from "@/services/jorney-detail";

export default {
  name: "lead-detail",
  components: {
  },
  props: ['lead_id'],
  data() {
    return {
      loading: false,
      detail: {
        lead: {},
        sales: [],
        subscriptions: [],
        products: [],
        trackers: [],
      },
    };
  },
  mounted() {
    this.getLead()
  },
  watch: {
  },
  methods: { 
    checkParam(p) {
      if (!p) {
        return false
      }

      if (p && (!p.includes("LUCREIHOJE") && !p.includes("UNICOTRACKER"))) {
        return true
      }
    },
    decodePv(pv) {
      var _m = {
        "LAST_PV": "Última Vísita antes de virar Lead",
        "FIRST_PV": "Primeira Vísita",
        "JORNEY_BEFORE": "Jornada Pré-Lead",
        "JORNEY_AFTER": "Jornada Pos-Lead",
      }

      return _m[pv] || pv
    },
    getLead() {
      this.loading = true
      getLead(this.lead_id)
      .then((result) => {
        this.detail = result
      })
      .catch((error) => {
        if (error && error.message === "request-canceled") {
            return;
          }
        this.$toast.error({
          title:'Erro',
          message:'Ocorreu algum problema'
        })
      })
      .finally(() => {
        this.loading = false
      })
    }

  }

};
</script>

<style lang="scss" scoped>
.grid-flex .box + .box, .flex .box + .box {
  margin-left: 0px;
}
.jorney-style {
  padding: 8px;
  border: 1px solid #c2c2c2;
  border-radius: 10px;
  margin-top: 4px;
}
.tag {
  background: var(--secondary);
  padding: 4px 8px;
  color: #fff;
  border-radius: 5px;
  font-weight: 400;
  margin-top: 4px;
  display: inline-block;
  max-width: 800px;
}
</style>
